import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, get, forEach, includes, toLower, isEmpty, isEqual } from 'lodash';
import { Form, Button, Col, InputGroup, Row } from 'react-bootstrap';
import { Bert } from 'meteor/themeteorchef:bert';

import { getURL } from '../../../api/Layers/layer-operations';
import { LAYER_SUBTYPES, URL_REQUIRING_SUBTYPES, WMS_VERSIONS } from '../../../api/Layers/Layers';

import { getURLWithQueryParams } from '../../../modules/load-xml-from-url';

import LoadButton from '../LoadButton';

class LayerURLField extends Component {
  urlInput = React.createRef();

  state = {
    importFileName: '',
    urlForm: 'url'
  };

  componentDidUpdate(prevProps) {
    const { defaultUrl } = this.props;
    if (!isEqual(defaultUrl, prevProps.defaultUrl)) {
      this.urlInput.current.value = defaultUrl;
    }
  }

  loadInputFile = async event => {
    const { handleURLChange } = this.props;

    const file = event.target.files[0];
    event.preventDefault();

    if (!file) {
      Bert.alert('Selecciona un archivo primero', 'danger');
      this.setState({ importFileName: '' });
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('disc', 'data3');

    try {
      const response = await fetch('https://sd1.d3.ipsilum.com/upload', {
        method: 'POST',
        body: formData,
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });

      this.setState({ importFileName: file.name });

      const respuesta = await response.json();
      this.setState({ urlForm: 'url' });
      handleURLChange();
      this.urlInput.current.value = respuesta.data.link;
    } catch (error) {
      console.error('Error:', error);
    }
  };

  toggleButtonSwitch = (thisButton = '') => {
    this.setState(prevState => {
      const newButtonStates = cloneDeep(prevState.buttonStates);
      forEach(prevState.buttonStates, (myButton, key) => {
        if (thisButton !== key && myButton) newButtonStates[key] = false;
      });
      if (thisButton) newButtonStates[thisButton] = !prevState.buttonStates[thisButton];
      return { buttonStates: newButtonStates };
    });
  };

  render() {
    const {
      defaultUrl,
      layerSubType,
      loadGeoJSON,
      loadTopoJSON,
      load3DTiles,
      geojsonLoading,
      layer,
      loadWMTSLayer,
      loadWMSLayers,
      loadCSV,
      loadFiwareVersion,
      failedFetchDueToCORS,
      handleURLChange,
      loadMapBoxLayersOrGeoJSON,
      loadOGR,
      loadExcel
    } = this.props;

    const { importFileName, urlForm } = this.state;

    if (!includes(URL_REQUIRING_SUBTYPES, layerSubType)) return '';

    const showLoadButton = includes(
      [
        LAYER_SUBTYPES.WMS,
        LAYER_SUBTYPES.WMTS,
        LAYER_SUBTYPES.GEOJSON,
        LAYER_SUBTYPES.TOPOJSON,
        LAYER_SUBTYPES.CSV,
        LAYER_SUBTYPES.CESIUM3DTILESET,
        LAYER_SUBTYPES.FIWARE,
        LAYER_SUBTYPES.GEOJSONVT,
        LAYER_SUBTYPES.MAPBOX,
        LAYER_SUBTYPES.REALTIME,
        LAYER_SUBTYPES.OGR,
        LAYER_SUBTYPES.EXCEL,
        LAYER_SUBTYPES.GOOGLE_SHEETS,
        LAYER_SUBTYPES.INDOOR
      ],
      layerSubType
    );
    const urlvalue = isEmpty(defaultUrl) ? getURL(layer) : defaultUrl;

    const params = {
      request: 'GetCapabilities',
      service: toLower(layerSubType),
      version: LAYER_SUBTYPES.WMS === layerSubType ? WMS_VERSIONS.V130 : WMS_VERSIONS.V100
    };
    const urlInputValue = get(this, 'urlInput.current.value', '');
    const getCapabilitiesURL = getURLWithQueryParams(urlInputValue, params);
    let clickAction;
    switch (true) {
      case includes(
        [
          LAYER_SUBTYPES.GEOJSON,
          LAYER_SUBTYPES.GEOJSONVT,
          LAYER_SUBTYPES.REALTIME,
          LAYER_SUBTYPES.INDOOR
        ],
        layerSubType
      ):
        clickAction = loadGeoJSON;
        break;
      case LAYER_SUBTYPES.TOPOJSON === layerSubType:
        clickAction = loadTopoJSON;
        break;
      case LAYER_SUBTYPES.WMS === layerSubType:
        clickAction = loadWMSLayers;
        break;
      case LAYER_SUBTYPES.WMTS === layerSubType:
        clickAction = loadWMTSLayer;
        break;
      case LAYER_SUBTYPES.CSV === layerSubType:
        clickAction = loadCSV;
        break;
      case LAYER_SUBTYPES.CESIUM3DTILESET === layerSubType:
        clickAction = load3DTiles;
        break;
      case LAYER_SUBTYPES.FIWARE === layerSubType:
        clickAction = loadFiwareVersion;
        break;
      case LAYER_SUBTYPES.MAPBOX === layerSubType:
        clickAction = loadMapBoxLayersOrGeoJSON;
        break;
      case LAYER_SUBTYPES.OGR === layerSubType:
        clickAction = loadOGR;
        break;
      case includes([LAYER_SUBTYPES.EXCEL, LAYER_SUBTYPES.GOOGLE_SHEETS], layerSubType):
        clickAction = loadExcel;
        break;
      default:
        clickAction = () => console.error('Not Supported Yet');
        break;
    }
    return (
      <>
        {layerSubType === LAYER_SUBTYPES.GEOJSON && (
          <Row
            style={{
              display: 'flex',
              justifyContent: 'left',
              alignItems: 'left',
              marginLeft: '1px'
            }}
          >
            <Button
              variant={urlForm === 'url' ? 'secondary' : 'light'}
              style={{ width: '15%', fontSize: 11 }}
              onClick={() => this.setState({ urlForm: 'url' })}
              disabled={urlForm === 'url'}
            >
              Url
            </Button>
            <Button
              variant={urlForm === 'upload' ? 'secondary' : 'light'}
              style={{ width: '20%', fontSize: 11 }}
              onClick={() => this.setState({ urlForm: 'upload' })}
              disabled={urlForm === 'upload'}
            >
              Upload file
            </Button>
          </Row>
        )}
        {urlForm === 'url' && (
          <Form.Group>
            {layerSubType !== LAYER_SUBTYPES.GEOJSON && (
              <Form.Label>
                {layerSubType === LAYER_SUBTYPES.FIWARE && 'Fiware Token'} URL
              </Form.Label>
            )}
            <Form.Row>
              <Col xs={showLoadButton ? 10 : 12}>
                <Form.Control
                  type="text"
                  name="url"
                  id="UrlField"
                  ref={this.urlInput}
                  defaultValue={urlvalue}
                  placeholder="Where is your layer?"
                  onChange={handleURLChange}
                />
              </Col>
              {showLoadButton && (
                <Col xs={2}>
                  <LoadButton isLoading={geojsonLoading} clickAction={clickAction} />
                </Col>
              )}
            </Form.Row>
            {failedFetchDueToCORS && (
              <Form.Text className="text-muted text-break">
                Fetch failed. Check
                <a href={getCapabilitiesURL} target="_blank" rel="noreferrer noopener">
                  {getCapabilitiesURL}
                </a>
                to get WMS layer names
              </Form.Text>
            )}
          </Form.Group>
        )}
        {urlForm === 'upload' && (
          <Form.Group>
            <InputGroup>
              <Form.Control
                type="file"
                name="importFileName"
                className="custom-file-input"
                id="importFileName"
                aria-describedby="importFileName"
                onFocus={() => this.toggleButtonSwitch()}
                onChange={this.loadInputFile}
                placeholder="Upload your file"
              />
              <InputGroup.Append>
                <Form.Label className="custom-file-label col-12" htmlFor="importFileName">
                  {!isEmpty(importFileName) ? importFileName : 'Upload file'}
                </Form.Label>
              </InputGroup.Append>
            </InputGroup>
          </Form.Group>
        )}
      </>
    );
  }
}
LayerURLField.defaultProps = {
  defaultUrl: ''
};

LayerURLField.propTypes = {
  defaultUrl: PropTypes.string,
  layerSubType: PropTypes.string.isRequired,
  loadGeoJSON: PropTypes.func.isRequired,
  load3DTiles: PropTypes.func.isRequired,
  loadTopoJSON: PropTypes.func.isRequired,
  loadWMSLayers: PropTypes.func.isRequired,
  loadWMTSLayer: PropTypes.func.isRequired,
  loadCSV: PropTypes.func.isRequired,
  loadFiwareVersion: PropTypes.func.isRequired,
  geojsonLoading: PropTypes.bool.isRequired,
  layer: PropTypes.object.isRequired,
  failedFetchDueToCORS: PropTypes.bool.isRequired,
  handleURLChange: PropTypes.func.isRequired,
  loadMapBoxLayersOrGeoJSON: PropTypes.func.isRequired,
  loadOGR: PropTypes.func.isRequired,
  loadExcel: PropTypes.func.isRequired
};

export default LayerURLField;
